module.exports = __webpack_public_path__ + "img/userLogo2.7f12dd4d.jpg";